<template>
  <div>
    <v-select
      v-model="parentValue"
      :label="field.parentName"
      :items="parentItems"
      :item-text="field.parentOptionText ? field.parentOptionText : 'name'"
      :item-value="field.parentOptionValue ? field.parentOptionValue : 'id'"
      :loading="parentApi.isLoading"
      :rules="parentRules"
      @change="getParentChildItems"
      :outlined="outlined"
      :dense="dense"
      :hide-details="hideDetails"
    />

    <v-text-field
      v-model="form.data[field.parentOptionTextSaveAs]"
      :label="field.parentName"
      v-if="isShow"
      :outlined="outlined"
      :dense="dense"
      :hide-details="hideDetails"
    />

    <v-select
      v-model="childValue"
      :label="field.childName"
      :items="childItems"
      :item-text="field.childOptionText ? field.childOptionText : 'name'"
      :item-value="field.childOptionValue ? field.childOptionValue : 'id'"
      :loading="childApi.isLoading"
      :rules="childRules"
      :outlined="outlined"
      :dense="dense"
      :hide-details="hideDetails"
    />

    <v-text-field
      v-model="form.data[field.childOptionTextSaveAs]"
      :label="field.childName"
      v-if="isShow"
      :outlined="outlined"
      :dense="dense"
      :hide-details="hideDetails"
    />

  </div>
    
  </template>
  
  <script>
  import Api from "@/objects/api";
  import Model from "@/objects/model";
  import Service from "@/objects/service";
  import { mapState } from "vuex";
  export default {
    computed: mapState({
      auth: (state) => state.auth.data,
      services: (state) => state.service.data.services,
      rolePermission: (state) => state.rolePermission.data,
    }),
    props: {
      field: {
        type: Object,
      },
      parentRules: {
        type: Array,
      },
      childRules: {
        type: Array,
      },
      form: {
        type: Object,
      },
      /**
       * Field chrome, off by default so every existing add / child-add form
       * keeps the underline select it has always rendered. A host that lays
       * these out beside outlined inputs passes them so the rows line up —
       * see BreadTabulatorFormSelectModel for the why.
       */
      outlined: {
        type: Boolean,
        default: false,
      },
      dense: {
        type: Boolean,
        default: false,
      },
      hideDetails: {
        type: [Boolean, String],
        default: false,
      },
    },
    watch: {
      parentValue(parentNewValue) {

        if(this.field.parentOptionTextSaveAs)  {
          let parentValue = parentNewValue;
        let parentTextValue = this.parentItems.find(item => item[this.field.parentOptionValue] === parentValue);
        this.form.setDataProperty(this.field.parentOptionTextSaveAs, parentTextValue[this.field.parentOptionText]);
        }
        this.$emit("inputParent", parentNewValue);
      },

      childValue(childNewValue) {
        if(this.field.childOptionTextSaveAs)  {
          let childValue = childNewValue;
          let childTextValue = this.childItems.find(item => item[this.field.childOptionValue] === childValue);
          this.form.setDataProperty(this.field.childOptionTextSaveAs, childTextValue[this.field.childOptionText]);
        }
        this.$emit("inputchild", childNewValue);
      },
    },
    data: () => ({
      parentApi: new Api(),
      childApi: new Api(),
      parentModel: new Model(),
      childModel: new Model(),
      parentService: new Service(),
      childService: new Service(),
      parentItems: [],
      childItems: [],
      parentValue:null,
      childValue:null,
      isShow: false,
    }),
    created() {
      this.parentModel.getByKey(this.field.parentModelKey);
      this.childModel.getByKey(this.field.childModelKey);
      if(this.parentModel.serviceKey) this.parentService.set("key",this.parentModel.serviceKey);
      if(this.childModel.serviceKey) this.childService.set("key",this.childModel.serviceKey);
      if(this.field.parentApiListUrl) {
        this.parentApi.setUrl(
        `${this.$service[this.parentService.key]}${this.field.parentApiListUrl}`
      );
      }else{
        this.parentApi.setUrl(
        `${this.$service[this.parentService.key]}/v1/en/console/tabulator/model/${this.field.parentModelKey}/upsert/dropdown`
      );
      }
      
      this.parentApi.setCallbackCompleted((response) => {
        this.parentItems = response.data;
      });
      this.parentApi.fetch();

    },
    methods: {
      getParentChildItems(){
        
        let parentValue = this.parentValue;

        var internalUserRole  = this.auth.roles;
        var internalUserUuid = this.auth.uuid;

        // find sales-lead in the internalUserRole

        var internalUserRoleSlug = internalUserRole.map((role) => role.slug);

        if(internalUserRoleSlug.includes('sales-lead') && this.field.childModelKey == 'ssoTeam') {
          this.childApi.setUrl(
            `${this.$service[this.childService.key]}/v1/en/console/${this.field.childModelKey}/list/${parentValue}/${internalUserUuid}`
          );
        }else if(this.field.childApiListUrl) {
        this.childApi.setUrl(
        `${this.$service[this.childService.key]}${this.field.childApiListUrl}/${parentValue}`
      );
      }else{
        this.childApi.setUrl(
        `${this.$service[this.childService.key]}/v1/en/console/tabulator/model/${this.field.childModelKey}/upsert/dropdown`
      );
      }

      this.childApi.setCallbackCompleted((response) => {
        this.childItems = response.data;
      });
      this.childApi.fetch();
      },
    },
  };
  </script>